/* jslint browser: true */
/* global window */
import React, { Component } from 'react';

class NavMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sectionsFront: [
                { nom: 'Mon compte', url: '/moncompte' },
                { nom: 'Commander des programmes', url: '/commande' },
                { nom: 'Créer une fiche client', url: '/programme' }
            ],
            sectionsBack: [
                { nom: 'Professionnels', url: '/admin/pro' },
                { nom: 'Menus', url: '/admin/menus' },
                { nom: 'Annexes', url: '/admin/annexes' }
            ]
        };
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentWillMount() {}

    componentDidMount() {}

    handleSearch(url) {
        window.location = url;
    }

    render() {
        return (
            <div className="nav-menu">
                <ul className="sections">
                    {window.location.pathname.indexOf('admin') !== -1
                        ? this.state.sectionsBack.map((section, index) => (
                              <li
                                  onClick={e => this.handleSearch(section.url)}
                                  className={
                                      window.location.pathname.indexOf(
                                          section.url
                                      ) !== -1 && 'active'
                                  }
                                  key={index}
                                  style={{
                                      width: `calc(100% / ${
                                          this.state.sectionsBack.length
                                      })`,
                                      cursor: 'pointer'
                                  }}
                              >
                                  <a
                                      style={{ textDecoration: 'none' }}
                                      href={section.url}
                                  >
                                      {section.nom}
                                  </a>
                              </li>
                          ))
                        : this.state.sectionsFront.map((section, index) => (
                              <li
                                  onClick={e => this.handleSearch(section.url)}
                                  className={
                                      window.location.pathname.indexOf(
                                          section.url
                                      ) !== -1 && 'active'
                                  }
                                  key={index}
                                  style={{
                                      width: `calc(100% / ${
                                          this.state.sectionsFront.length
                                      })`,
                                      cursor: 'pointer'
                                  }}
                              >
                                  <a
                                      style={{ textDecoration: 'none' }}
                                      href={section.url}
                                  >
                                      {section.nom}
                                  </a>
                              </li>
                          ))}
                </ul>
            </div>
        );
    }
}

export default NavMenu;



// WEBPACK FOOTER //
// ./src/components/NavMenu.js